import ElementGroups from "@ext/markdown/core/element/ElementGroups";

const noteTitle = {
	content: `${ElementGroups.inline}*`,
	marks: "",
	defining: true,
	selectable: false,
};

export default noteTitle;
